import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { BlocoObrasResponsabilidadeComponent } from './bloco-obras-responsabilidade/bloco-obras-responsabilidade.component';
import { BlocoBuscasSalvasComponent } from './bloco-buscas-salvas/bloco-buscas-salvas.component';
import { BlocoNovasOportunidadesComponent } from './bloco-novas-oportunidades/bloco-novas-oportunidades.component';
import { BlocoSolicitarNovaObraComponent } from './bloco-solicitar-nova-obra/bloco-solicitar-nova-obra.component';
import { BlocoTarefasComponent } from './bloco-tarefas/bloco-tarefas.component';
import { BlocoStatusRedeComponent } from './bloco-status-rede/bloco-status-rede.component';
import { BlocoRelatoriosComponent } from './bloco-relatorios/bloco-relatorios.component';
import { AuthService } from '../shared/services/auth/auth.service';
import { Router } from '@angular/router';
import { ObraNavegacaoService } from '../shared/services/obras-navegacao/obras-navegacao.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    BlocoObrasResponsabilidadeComponent,
    BlocoBuscasSalvasComponent,
    BlocoNovasOportunidadesComponent,
    BlocoSolicitarNovaObraComponent,
    BlocoTarefasComponent,
    BlocoStatusRedeComponent,
    BlocoRelatoriosComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  exibirFichaDaObra = false;
  idObraSelecionada: number | null = null;
  obraIds: number[] = [];
  indiceObraAtual = 0;

  constructor( @Inject(AuthService) private authService: AuthService, private router: Router, private obraNavegacaoService: ObraNavegacaoService) {}

  ngOnInit(): void {
    // this.showPopupAviso();
  }

  // showPopupAviso(): void {
  //   const userId = this.authService.userID;
  //   const storageKey = userId ? `popup_home_visualized_${userId}` : 'popup_home_visualized';
  //   const hasVisualized = localStorage.getItem(storageKey);

  //   if (!hasVisualized) {
  //     this.modalService.show(PopUpAvisoComponent, {
  //       initialState: {
  //         userId: userId || undefined,
  //       },
  //     });
  //   }
  // }

  abrirFichaObra(event: {
    workID: number;
    obraIds: number[];
    modulo: string;
  }): void {
    if (!event?.workID || !event.modulo) {
      return;
    }

    this.obraNavegacaoService.setObraIds(event.obraIds, event.modulo);
    this.router.navigate(['/buscas', event.modulo, 'detalhes', event.workID]);
  }
  
}
